function classNames(...args) {
  return [...args].join(' ');
}
export default classNames;
//# sourceMappingURL=classnames.utils.js.map
